import CreatePresetBarcodePDFModal from './CreatePresetBarcodePDFModal.js'
import CustomsModal from './CustomsModal/index.js'
import DeletePresetModal from './DeletePresetModal.js'
import EditAdditionalOptionsModal from './EditAdditionalOptionsModal.js'
import EditDimensionsModal from './EditDimensionsModal.js'
import EditPresetModal from './EditPresetModal/index.js'
import EditWeightDimensionsModal from './EditWeightDimensionsModal.js'
import EditWeightModal from './EditWeightModal.js'
import ETDPreshipmentDocsModal from './ETDPreshipmentDocsModal.js'
import HazmatModal from './HazmatModal.js'
import HoldAtLocationModal from './HoldAtLocationModal.js'
import ImporterOfRecordModal from './ImporterOfRecordModal.js'
import InsuranceModal from './InsuranceModal.js'
import MultiboxModal from './MultiboxModal/index.js'
import PostageBalanceModal from './PostageBalanceModal.js'
import RemoveHazmatItemModal from './RemoveHazmatItemModal.js'
import TaxInfoModal from './TaxInfoModal.js'

export default function Modals() {
  return (
    <>
      <EditPresetModal />
      <CreatePresetBarcodePDFModal />
      <CustomsModal />
      <DeletePresetModal />
      <EditAdditionalOptionsModal />
      <EditDimensionsModal />
      <EditWeightDimensionsModal />
      <EditWeightModal />
      <ETDPreshipmentDocsModal />
      <HazmatModal />
      <HoldAtLocationModal />
      <ImporterOfRecordModal />
      <InsuranceModal />
      <MultiboxModal />
      <PostageBalanceModal />
      <RemoveHazmatItemModal />
      <TaxInfoModal />
    </>
  )
}
